// imports
import clsx from 'clsx';
import React from 'react';

// interfaces / types / consts
interface Props {
  text?: string;
  badge?: number;
  leftIcon?: string;
  rightIcon?: string;
  className?: string;
  disabled?: boolean;
  textElemId?: string;
  isLoading?: boolean;
  toggleElem?: 'dropdown';
  hoverEffect?: 'shine' | 'brightness';
  size?: 'lg' | 'md' | 'md-skinny' | 'sm';
  onClick?: () => void;
}

// exports
export default function PrimaryButton(props: Props): JSX.Element {
  const {
    textElemId, text, badge, leftIcon, rightIcon,
    className, toggleElem, disabled, isLoading,
    size = 'lg', hoverEffect = 'brightness',
    onClick
  } = props;
  // render
  return (
    <button
      type="button"
      disabled={disabled}
      data-bs-toggle={toggleElem}
      className={clsx('container-outer', className, size, hoverEffect, textElemId && 'pointer')}
      onClick={onClick}
    >
      <div className="container-inner">
        {leftIcon && <img className={clsx('left-icon', isLoading && 'rotate-image')} src={leftIcon} alt="" />}
        <span id={textElemId} className={clsx('text', isLoading && 'with-spinner')}>{text}</span>
        {isLoading && <span className="spinner" />}
        {rightIcon && <img className="right-icon" src={rightIcon} alt="" />}
      </div>
      {badge! > 0 && <span className="notification-badge">{badge}</span>}
    </button>
  );
}

// default props
PrimaryButton.defaultProps = {
  badge: 0,
  text: '',
  size: 'lg',
  leftIcon: '',
  rightIcon: '',
  className: '',
  textElemId: '',
  toggleElem: '',
  disabled: false,
  isLoading: false,
  hoverEffect: 'brightness',
  onClick: () => null
};
